import React from 'react';

import { Box, Typography, Button } from '@mui/material';

import { LastMonthMembershipAnnouncementCheckboxKey, LastMonthMembershipAnnouncementCheckboxState } from './types';

interface ConfirmationStepProps {
  checkboxes: LastMonthMembershipAnnouncementCheckboxState;
  labels: Record<LastMonthMembershipAnnouncementCheckboxKey, string>;
  handleBack: () => void;
  onConfirm: (selectedItems: string[]) => void;
}

const ConfirmationStep: React.FC<ConfirmationStepProps> = ({ checkboxes, labels, handleBack, onConfirm }) => {
  const selectedItems = Object.entries(checkboxes)
    .filter(([_, checked]) => checked)
    .map(([key]) => labels[key as LastMonthMembershipAnnouncementCheckboxKey]);
  const selectedKeys = Object.keys(checkboxes).filter(
    (key) => checkboxes[key as LastMonthMembershipAnnouncementCheckboxKey],
  );

  return (
    <Box>
      <Typography sx={{ marginBottom: 3, fontWeight: 'bold', fontSize: '1.8rem', textAlign: 'center' }}>
        下記内容で公開催促メールを送信しますか？
      </Typography>
      <Box sx={{ marginBottom: 4, padding: 2, backgroundColor: '#f5f5f5', borderRadius: 2 }}>
        <Typography sx={{ fontSize: '1.6rem', fontWeight: 'bold', textAlign: 'center' }}>
          {selectedItems.length > 0 && selectedItems.join(', ')}
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'center', width: '60%', margin: '0 auto' }}>
        <Button
          variant="outlined"
          onClick={handleBack}
          sx={{
            fontWeight: 'bold',
            fontSize: '2rem',
            padding: '1rem',
            margin: '1rem auto 0',
            width: '300px',
          }}
        >
          戻る
        </Button>
        <Button
          variant="contained"
          onClick={() => onConfirm(selectedKeys)}
          sx={{
            backgroundColor: '#3b83c3',
            '&:hover': {
              backgroundColor: '#36759f',
            },
            fontWeight: 'bold',
            fontSize: '2rem',
            padding: '1rem',
            margin: '1rem auto 0',
            width: '300px',
          }}
        >
          送信
        </Button>
      </Box>
    </Box>
  );
};

export default ConfirmationStep;
